import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-363">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-364">
        <Link to="/" className="text-2xl font-bold tracking-tighter flex items-center" data-id="element-365">
          <span style={{
          color: '#ff6b6b'
        }} data-id="element-366">
            Fling
          </span>
          <span data-id="element-367">Link</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-368">
          <Link to="/how-it-works" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-369">
            How it works
          </Link>
          <Link to="/pricing" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-370">
            Pricing
          </Link>
          <Link to="/safety" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-371">
            Safety
          </Link>
        </nav>

        <div className="hidden md:flex items-center gap-4" data-id="element-372">
          <a href="https://me.flinglink.app" className="text-sm font-medium hover:text-primary transition-colors" data-id="element-373">
            Log in
          </a>
          <a href="https://me.flinglink.app/signup" data-id="element-374">
            <Button size="sm" style={{
            backgroundColor: '#ff6b6b'
          }} data-id="element-375">
              Get Started
            </Button>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={toggleMenu} data-id="element-376">
          {isMenuOpen ? <X data-id="element-377" /> : <Menu data-id="element-378" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-379">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-380">
            <nav className="flex flex-col p-4 gap-4" data-id="element-381">
              <Link to="/how-it-works" className="text-lg font-medium py-2 border-b border-gray-50" onClick={toggleMenu} data-id="element-382">
                How it works
              </Link>
              <Link to="/pricing" className="text-lg font-medium py-2 border-b border-gray-50" onClick={toggleMenu} data-id="element-383">
                Pricing
              </Link>
              <Link to="/safety" className="text-lg font-medium py-2 border-b border-gray-50" onClick={toggleMenu} data-id="element-384">
                Safety
              </Link>
              <div className="flex flex-col gap-3 mt-4" data-id="element-385">
                <a href="https://me.flinglink.app" onClick={toggleMenu} data-id="element-386">
                  <Button variant="outline" className="w-full justify-center" data-id="element-387">
                    Log in
                  </Button>
                </a>
                <a href="https://me.flinglink.app/signup" onClick={toggleMenu} data-id="element-388">
                  <Button className="w-full justify-center" style={{
                backgroundColor: '#ff6b6b'
              }} data-id="element-389">
                    Get Started
                  </Button>
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}